import React from "react";
import Grid from "@material-ui/core/Grid";
import Radio from "@material-ui/core/Radio";
import RadioGroup from "@material-ui/core/RadioGroup";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import FormControl from "@material-ui/core/FormControl";
import Typography from "@material-ui/core/Typography";

export default function dailyTopicMail({ state, onChangeDtmEnable }) {
  return (
    <Grid item xs={12}>
      <Typography variant="h6" gutterBottom>
        デイリートピックメール
      </Typography>
      <Grid item>
        <FormControl component="fieldset">
          <RadioGroup onChange={onChangeDtmEnable} value={state.dtm_enable}>
            <FormControlLabel
              value={false}
              control={<Radio />}
              label="このグループを掲載しない"
            />
            <FormControlLabel
              value={true}
              control={<Radio />}
              label="このグループを掲載する"
            />
          </RadioGroup>
        </FormControl>
        <Grid item>
          <Typography variant="body2">
            ※デイリートピックメールの送信先は、ユーザ設定から変更することができます。
          </Typography>
        </Grid>
      </Grid>
    </Grid>
  );
}
